import React, { Component } from 'react'
import { IMG, COLOR, getFontContrastColor } from '../../themes'
import { BUTTON } from './style'

export class ButtonCreate extends Component {
  render () {
    const { onClick, settingReducer } = this.props
    const { colorTheme } = settingReducer.settingTheme
    const colorBackground = (colorTheme && colorTheme !== '') ? colorTheme : COLOR.GOLD_1

    let imageName = 'ic_round-plus.svg'

    return (
      <BUTTON
        onClick={onClick}
        style={{ background: colorBackground }}
      >
        <img
          className='image-add'
          src={IMG[imageName]}
          alt='add'
        />
      </BUTTON>
    )
  }
}
